<template>
  <div>
    <div :id="id" style="width:8rem;height:8rem;"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import EmCommonApi from "@/mixin/em/common/api";

export default {
  mixins: [EmCommonApi],
  data() {
    return {
      //颜色对象
      colorObj: {
          textStyle: "",
          series: {
            color: [],
            dataColor: {
              normal: "",
              shadowColor: ""
            }
          }
      },
      temperature:0
    };
  },

  props: {
    id: {
      type: String,
      required: true,
      default: "chartRate"
    },
    eocId: {
      type: String,
      required: true,
      default:"0"
    },

  },
  created() {
    this.getRemoteData();
  },
  mounted() {
    //定时轮巡查询
    this.fresh = setInterval(() => {
      this.getRemoteData();
      //window.addEventListener('resize', this.chart.resize, false)
    },  10000);

  },
  destroyed() {
    clearInterval(this.fresh);
    //window.removeEventListener('resize', this.chart.resize, false)
  },
  computed:{
  },
  methods: {
    getRemoteData() {
      const _api = this.$_emApiMixin_moduleBaseApi("emOpcComputedEoc") +
          "/emOpcUaResource/getFromComputedId?" +
          "id=" + this.eocId

      this.$_emApiMixin_get(_api)
          .then((res) => {
            // console.log("提取监控设备温度数据：")
            // console.log(res)

            this.temperature = res.newValue.value
            this.drawPie();  //异步渲染echarts
          })


      //2021.9.26 赵楼调试
      // ----- 测试数据 -----
      // console.log("EM = " + this.id);
      // if(this.id == "em1"){
      //   this.temperature = Math.floor(Math.random()*(46-40+1)+46);
      // }else if(this.id == "em2"){
      //   this.temperature = Math.floor(Math.random()*(66-60+1)+66);
      // }else if(this.id == "em3"){
      //   this.temperature = Math.floor(Math.random()*(80-70+1)+80);
      // }else if(this.id == "em4"){
      //   this.temperature = Math.floor(Math.random()*(95-90+1)+90);
      // }
      // this.drawPie();
      // console.log("温度 = " + this.temperature);
      // -------------------
    },

    drawPie() {

      // 基于准备好的dom，初始化echarts实例
      let myChartPieLeft = echarts.init(document.getElementById(this.id));

      //颜色范围判断
      //TODO：这个范围需要后期和客户确定
      // tips < 60 绿色
      // 60 < tips < 80 蓝色
      // 80 < tips < 90 橙色
      // tips > 90 红色
      //原始文字颜色 3fc0fb
      if(this.temperature < 60){
        //绿色
        this.colorObj.textStyle = "#99FF99";                       //中间字体颜色
        this.colorObj.series.color = ["#99FF994a", "transparent"]; //未完成圈颜色  (最后2位似乎是透明作用) ["#00bcd44a", "transparent"]
        this.colorObj.series.dataColor.normal = "#00CC00";         //完成圈颜色  #03a9f4
        this.colorObj.series.dataColor.shadowColor = "#99FF66";    //完成圈阴影颜色  #97e2f5
      }else if(this.temperature >=60 && this.temperature < 80){
        //蓝色
        this.colorObj.textStyle = "#03a9f4";                       //中间字体颜色
        this.colorObj.series.color = ["#00bcd44a", "transparent"]; //未完成圈颜色  (最后2位似乎是透明作用) ["#00bcd44a", "transparent"]
        this.colorObj.series.dataColor.normal = "#03a9f4";         //完成圈颜色  #03a9f4
        this.colorObj.series.dataColor.shadowColor = "#97e2f5";    //完成圈阴影颜色  #97e2f5
      }else if(this.temperature >=80 && this.temperature < 90){
        //橙色
        this.colorObj.textStyle = "#ff9800";                       //中间字体颜色
        this.colorObj.series.color = ["#faf3a34a", "transparent"]; //未完成圈颜色  (最后2位似乎是透明作用) ["#00bcd44a", "transparent"]
        this.colorObj.series.dataColor.normal = "#ff9800";         //完成圈颜色  #03a9f4
        this.colorObj.series.dataColor.shadowColor = "#fcebad";    //完成圈阴影颜色  #97e2f5
      }else if(this.temperature >= 90){
        //红色
        this.colorObj.textStyle = "#FF0000";                       //中间字体颜色
        this.colorObj.series.color = ["#FF00004a", "transparent"]; //未完成圈颜色  (最后2位似乎是透明作用) ["#00bcd44a", "transparent"]
        this.colorObj.series.dataColor.normal = "#FF0000";         //完成圈颜色  #03a9f4
        this.colorObj.series.dataColor.shadowColor = "#FF6666";    //完成圈阴影颜色  #97e2f5
      }



      let option = {
        title: [
          {
            text: this.temperature * 1 + "°C",
            x: "center",
            y: "center",
            textStyle: {
              color: this.colorObj.textStyle,
              fontSize: 16
            }
          }
        ],
        series: [
          {
            type: "pie",
            radius: ["75%", "80%"],
            center: ["50%", "50%"],
            hoverAnimation: false,
            color: this.colorObj.series.color,
            label: {
              normal: {
                show: false
              }
            },
            data: [
              {
                value: this.temperature,
                itemStyle: {
                  normal: {
                    color: this.colorObj.series.dataColor.normal,
                    shadowBlur: 10,
                    shadowColor: this.colorObj.series.dataColor.shadowColor
                  }
                }
              },
              {
                value: 100 - this.temperature   //上限计算
              }
            ]
          }
        ]
      };
      myChartPieLeft.setOption(option);
      // -----------------------------------------------------------------
      // 响应式变化
      window.addEventListener("resize", () => myChartPieLeft.resize(), false);
    }
  },

};
</script>

<style lang="scss" scoped>
</style>